import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import CustomForm from 'src/components/CustomForm';
import { ADD_CHAPTER_FIELDS, EDIT_CHAPTER_FIELDS } from 'src/utils/constants';
import { Form } from 'antd';
import useWindowSize from 'src/utils/hooks//useWindowSize';
import { useDispatch, useSelector } from 'react-redux';
import chapterActions from 'src/redux/actions/chapterActions';
import Loading from 'src/components/Loading';
import chapterSelectors from 'src/redux/selectors/chapterSelectors';
import comicActions from 'src/redux/actions/comicActions';

const ModalAddChapter = ({ visible, onCancel, comic, editingChapter }) => {
  const dispatch = useDispatch();
  const { windowHeight } = useWindowSize();
  const [form] = Form.useForm();
  const loading = useSelector(chapterSelectors.loading);
  const inputFileType = Form.useWatch('inputFileType', form);
  const chapterContent = Form.useWatch('chapterContent', form);
  const shouldUpdateChapterContent = Form.useWatch('shouldUpdateChapterContent', form);
  const [disabled, setDisabled] = useState(false);

  const fetchComics = () => {
    dispatch(comicActions.fetchComics());
  };

  const fetchChapters = () => {
    dispatch(chapterActions.fetchChapters({ comicId: comic.id }));
  };

  useEffect(() => {
    (editingChapter && visible) && setDisabled(!shouldUpdateChapterContent);
  }, [shouldUpdateChapterContent, visible]);

  useEffect(() => {
    editingChapter && form.setFieldValue('name', editingChapter.name);
  }, [editingChapter]);

  const ASYNC_ADD_CHAPTER_FIELDS = (editingChapter ? EDIT_CHAPTER_FIELDS : ADD_CHAPTER_FIELDS).map(field => {
    switch (field.name) {
      case 'clearSelectedFiles':
        return {
          ...field,
          inputProps: {
            ...field.inputProps,
            icon: <span style={{ fontWeight: 'bold', marginRight: 10 }}>X</span>,
            danger: true,
            style: { marginBottom: 20 },
            onClick: () => form.setFieldValue('chapterContent', undefined),
            disabled: disabled || !chapterContent?.length > 0
          }
        };
      case 'chapterContent':
        return {
          ...field,
          inputProps: {
            ...field.inputProps,
            disabled,
            ...(inputFileType === 'directory' && { directory: true, multiple: false }),
          },
          ...(shouldUpdateChapterContent && {
            rules: [
              {
                required: true,
                message: 'Please select chapter content!',
              },
            ],
          })
        };
      case 'inputFileType':
        return {
          ...field,
          inputProps: {
            ...field.inputProps,
            disabled
          }
        }
      default:
        return field;
    }
  });

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log(values);
        if (editingChapter) {
          dispatch(chapterActions.editChapter({ ...values, comicId: comic.id, chapterId: editingChapter.id }, () => {
            form.resetFields();
            onCancel();
            fetchChapters();
          }));
        } else {
          dispatch(chapterActions.addChapter({ ...values, comicId: comic.id }, () => {
            form.resetFields();
            fetchComics();
          }));
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  }

  return (
    <Modal
      title={editingChapter ? "Edit chapter" : "Add chapter"}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      maskClosable={false}
      centered
      bodyStyle={{ maxHeight: windowHeight - 200, overflowY: 'auto' }}
      destroyOnClose
    >
      <Loading loading={loading} />
      <CustomForm form={form} fields={ASYNC_ADD_CHAPTER_FIELDS} autoComplete='off' layout='vertical' />
    </Modal>
  )
}

export default ModalAddChapter;